import {
  Background,
  BackgroundGlobalStyles,
  Box,
  FakeInput,
  SearchboxStartpageMetadata,
  Teaser,
  Title,
  Keywords,
  TeaserOnSide,
} from './components';

type Props = {
  withTeaser?: boolean;
  withPromotions?: boolean;
  spacious?: boolean;
  isStartPage?: boolean;
  isSearchAndShuffle?: boolean;
  withKeywords?: boolean;
  withTitle?: boolean;
  className?: string;
};

export const FindJobsSearchBar: React.FC<Props> = ({
  withTeaser = false,
  withPromotions = false,
  spacious = false,
  isStartPage,
  isSearchAndShuffle = false,
  withTitle = true,
  withKeywords = false,
  className,
}) => {
  return (
    <>
      <BackgroundGlobalStyles />
      <Background
        $spacious={spacious}
        $isSearchAndShuffle={isSearchAndShuffle}
        className={className}
      >
        {isStartPage ? <SearchboxStartpageMetadata /> : null}
        <Box $isSearchAndShuffle={isSearchAndShuffle}>
          {withTeaser && !isSearchAndShuffle ? <Teaser /> : null}
          {withTitle ? <Title isSearchAndShuffle={isSearchAndShuffle} /> : null}
          <FakeInput
            withPromotions={withPromotions}
            isSearchAndShuffle={isSearchAndShuffle}
            withTitle={withTitle}
          />
        </Box>
        {withKeywords ? <Keywords isStartPage={isStartPage} /> : null}
        {isSearchAndShuffle && withTeaser ? <TeaserOnSide /> : null}
      </Background>
    </>
  );
};
